import styled from 'styled-components'

import List from '../../atoms/List'
import ListItem from '../../atoms/ListItem'
import Market from './Market'
import Link from '../../atoms/Link/styled'

// TODO: convert to column and make underline grow to width of text like an underline
const State = styled(ListItem)`
  font-size: 1.2em;
  font-weight: bold;
  break-inside: avoid;
  flex: 1 1 100% !important;
  max-width: 100% !important;

  ${Market} {
    font-size: 1rem;
    font-weight: normal;
    text-transform: none;
    flex: 0 0 100%;
    max-width: 100%;
    flex: 1 1 100% !important;
    max-width: 100% !important;
  }

  ${Market}:hover ${Link} {
    text-decoration: underline;
  }

  ${Market}::after {
    display: none;
  }

  ${List}:before {
    position: absolute;
    display: ${ props => props.variant === 'underline' ? 'block' : 'none' };
    content: " ";
    height: 2px;
    width: 20px;
    background-color: ${ props => props.theme.colors.tertiary };
  }
`

export default State
